import PropTypes from 'prop-types';
import { Map, Set } from 'immutable';
import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import BetsNg from './Bets/BetsNg';
import { ticketDetailBets } from '@/mytickets/detail/subs';
import i18n from 'nike-ui/src/common/i18n';
import { calculateNewAutomaticOddsAdvantage } from 'nike-ui/src/components/ticketus/handlers';
import { cashinIsLoading$ } from 'nike-ui/src/components/ticketus/subs';

function TicketBodyNg({ ticket, isActive, cashinClosingModeActive, eventualTotals }) {
    const extras = ticket.get('extras');

    const { subscribe } = useReframe();
    const isLoading = subscribe(cashinIsLoading$(ticket.get('ticketId')));

    const newAutomaticOddsAdvantage = calculateNewAutomaticOddsAdvantage(eventualTotals, extras, isLoading);

    return (
        <>
            <BetsScoreboardSubscriber isActive={isActive} ticket={ticket} />
            {newAutomaticOddsAdvantage && cashinClosingModeActive ? (
                <div className="ticket-body-odds-container flex flex-col justify-center py-20">
                    <div className="px-20 mb-5 flex justify-between">
                        <div className="fs-14 c-default-light">
                            {i18n('nui.ticketus.detailTiketu.aktualny-extrakurz')}
                        </div>
                        <div className="fs-14 c-default-light" data-atid="aktualny-extrakurz">
                            {newAutomaticOddsAdvantage?.currentExtraOdds}
                        </div>
                    </div>
                    <div className="px-20 flex justify-between">
                        <div className="fs-14 text-extra-bold">{i18n('nui.ticketus.detailTiketu.novy-extrakurz')}</div>
                        <div className="fs-14 text-extra-bold" data-atid="novy-extrakurz">
                            {newAutomaticOddsAdvantage?.newExtraOdds}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="tickets-detail-gap-20" />
            )}
        </>
    );
}

function getTicketMatches(bets) {
    return (bets || Set()).map(bet => bet.get('betEventId')).toSet();
}

function BetsScoreboardSubscriber({ isActive, ticket }) {
    const hash = ticket.get('hash');

    const derefSub = useReframe();
    const bets = derefSub(ticketDetailBets(hash));

    useEffect(() => {
        if (!isActive) {
            return;
        }
        dispatch(['ticketus/scoreboard/retain-matches', getTicketMatches(bets)]);
    }, [bets, isActive]);

    return <BetsNg {...{ ticket, bets }} />;
}

TicketBodyNg.propTypes = {
    ticket: PropTypes.instanceOf(Map)
};

export default TicketBodyNg;
